var _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaqImage1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 70,
    viewBox: "0 0 146 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2210_18623)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 20,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#BFE4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.026 76.7148C156.203 87.8752 142.924 87.6104 142.924 87.6104H125.151H117.98H107.77L107.275 83.9491C105.496 87.1126 103.611 87.4445 102.368 87.6104C94.9251 87.6104 92.9939 83.8538 90.5224 80.6586L77.3672 60.8304L84.1284 55.0931L98.0957 71.32C98.0957 67.3233 100.687 57.8046 103.06 55.0931C103.06 55.0931 106.322 50.3867 111.403 50.3867C112.744 50.3867 117.578 50.3867 117.578 50.3867L135.782 50.7327C141.074 51.5095 143.754 56.23 145.526 60.0254L153.026 76.7148Z",
    fill: "#6983FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.559 36.0629C128.559 40.4727 125.219 44.0492 121.099 44.0492C116.979 44.0492 115.125 39.6112 115.125 35.2014C112.325 29.6018 116.979 28.0801 121.099 28.0801C125.216 28.0766 128.559 31.6531 128.559 36.0629Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.569 63.666L141.132 76.966H125.188V87.3532",
    stroke: "white",
    strokeWidth: 1.01683,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.202 51.9648L123.357 61.9036L120.355 58.9026L117.072 62.5603L111.727 51.9648",
    stroke: "white",
    strokeWidth: 1.01683,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.795 76.7781L120.992 62.9097L122.143 60.7878L121.857 60.4912L120.487 62.7473L122.517 76.0473L119.594 80.1499L120.487 81.6116L123.795 76.7781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.043 60.6929L120.359 59.0088L118.396 61.1837L119.681 62.8501L115.508 76.9763L119.681 81.718L123.434 76.9763L120.829 62.8501L122.043 60.6929Z",
    fill: "#FF85D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.584 38.5096L114.305 32.9877C114.305 32.7405 115.591 34.46 117.61 34.6541C118.638 34.753 121.271 34.1916 123.383 32.624C125.971 35.498 125.392 39.823 125.392 39.823C126.98 38.5096 129.064 39.3746 129.124 40.9846C129.028 43.7421 126.804 43.4984 125.808 42.8311V50.8034L120.127 58.5496L117.723 50.8034V46.736C116.71 46.736 114.588 46.8632 113.695 45.0837C112.78 43.2548 113.723 40.0631 114.584 38.5096Z",
    fill: "#FECB4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.719 48.7942L121.444 46.3369C121.444 46.3369 120.289 46.5346 119.551 46.6088C118.834 46.6829 117.719 46.7147 117.719 46.7147V48.7942Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.839 36.5293C117.546 38.0439 118.704 38.9337 118.704 38.9337L117.32 41.3804H118.955",
    stroke: "black",
    strokeWidth: 1.01683,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.633 36.0488C121.229 35.9464 121.833 35.957 122.25 36.0735",
    stroke: "black",
    strokeWidth: 1.01683,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.211 36.1826C115.808 36.0802 116.411 36.0908 116.828 36.2073",
    stroke: "black",
    strokeWidth: 1.01683,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.055 43.8125C119.588 43.53 120.057 43.1523 120.319 42.8027",
    stroke: "black",
    strokeWidth: 1.01683,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.586 41.5922L127.563 39.9717",
    stroke: "black",
    strokeWidth: 1.01683,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.984 40.4688L127.969 41.3973",
    stroke: "black",
    strokeWidth: 1.01683,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.524 38.8277C121.723 38.8277 121.884 38.6664 121.884 38.4675C121.884 38.2687 121.723 38.1074 121.524 38.1074C121.325 38.1074 121.164 38.2687 121.164 38.4675C121.164 38.6664 121.325 38.8277 121.524 38.8277Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.102 38.9615C116.301 38.9615 116.462 38.8002 116.462 38.6013C116.462 38.4024 116.301 38.2412 116.102 38.2412C115.903 38.2412 115.742 38.4024 115.742 38.6013C115.742 38.8002 115.903 38.9615 116.102 38.9615Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002 82.7245L104.891 69.541",
    stroke: "white",
    strokeWidth: 1.01683,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2210_18623)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#BFE4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1045 29.167C18.9695 29.167 14.8047 34.0893 14.8047 40.1634C14.8047 42.5068 15.426 44.6828 16.4842 46.4673H31.7249C32.7831 44.6828 33.4044 42.5097 33.4044 40.1634C33.4016 34.0893 29.2396 29.167 24.1045 29.167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4387 53.3014C40.0158 48.1862 34.8325 47.1308 32.543 47.2443C32.543 47.2443 28.625 47.3152 27.5129 49.2586C26.8689 50.3849 26.8065 50.6714 26.8065 50.6714L9.22244 51.0062C4.11007 51.758 1.51984 56.3172 -0.190906 59.9855L-7.43958 76.1085C-10.5093 86.8893 2.31989 86.6339 2.31989 86.6339H19.4897H26.4178H38.1717H41.4996C54.4876 86.6339 54.0706 79.8761 51.625 71.7649C51.6279 71.2713 44.0955 56.7966 42.4387 53.3014Z",
    fill: "#6983FF",
    stroke: "black",
    strokeWidth: 0.817071
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7757 72.798L35.1636 52.5244L27.0156 54.2579L34.7154 79.536C35.2062 81.7177 37.1666 86.1945 41.0676 86.657",
    stroke: "white",
    strokeWidth: 0.817071,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3523 63.5039L4.04688 76.3529H19.4492V86.3876",
    stroke: "white",
    strokeWidth: 0.817071,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.736 48.2828L34.2567 52.6632L28.4209 53.903L27.1641 48.6686C28.4578 45.7294 30.6224 40.8979 30.7529 40.5007C30.8863 40.1007 31.4764 39.9361 31.7402 40.1915C31.8707 39.7234 32.8665 39.8822 32.8665 40.5007C33.6836 40.1915 33.8538 40.8894 33.8368 41.1504C34.512 40.8298 34.9376 41.4114 34.7844 41.8597C34.705 42.0923 34.3872 45.562 34.3872 45.562C33.9106 47.0515 32.736 48.2828 32.736 48.2828Z",
    fill: "#FF85D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6067 41.5938L33.1953 44.8649",
    stroke: "#FF01A1",
    strokeWidth: 0.817071,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1914 44.8643C32.4992 44.9068 30.9587 45.4657 30.3203 47.358",
    stroke: "#FF01A1",
    strokeWidth: 0.817071,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5989 40.9463L32.1875 44.2174",
    stroke: "#FF01A1",
    strokeWidth: 0.817071,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7551 40.5635L31.3438 43.8346",
    stroke: "#FF01A1",
    strokeWidth: 0.817071,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6997 39.2015L30.1536 35.9757C30.1054 35.6438 27.1151 32.8153 19.6196 35.3856C20.3601 37.7801 19.2621 40.4696 19.2621 40.4696C17.7273 39.2015 15.713 40.0384 15.6562 41.5931C15.7499 44.2571 17.8975 44.0216 18.8593 43.3776V51.0774C18.8593 51.0774 19.3756 52.4846 20.3601 52.9754C23.6681 54.8109 25.8668 52.2633 26.6725 51.0774V47.1452C27.6513 47.1452 29.7025 47.2672 30.5621 45.548C31.4416 43.7833 30.5309 40.7023 29.6997 39.2015Z",
    fill: "#FF85D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5742 41.3262C31.0168 43.0539 32.4155 46.9294 28.2422 47.1506",
    stroke: "#FF01A1",
    strokeWidth: 0.817071,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6783 49.1344L23.0781 46.7598C23.0781 46.7598 24.1931 46.9499 24.908 47.0208C25.6003 47.0917 26.6783 47.1257 26.6783 47.1257V49.1344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5518 37.2891C26.8355 38.753 25.7149 39.6126 25.7149 39.6126L27.054 41.9759H25.4766",
    stroke: "black",
    strokeWidth: 0.817071,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8573 36.8245C23.2813 36.7252 22.6997 36.7365 22.2969 36.85",
    stroke: "black",
    strokeWidth: 0.817071,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0945 36.9543C28.5185 36.855 27.9369 36.8664 27.5312 36.9799",
    stroke: "black",
    strokeWidth: 0.817071,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.384 44.3226C24.8677 44.0503 24.4137 43.6843 24.1641 43.3467",
    stroke: "black",
    strokeWidth: 0.817071,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0734 42.1804L17.1641 40.6172",
    stroke: "black",
    strokeWidth: 0.817071,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.716 41.0938L16.7656 41.9931",
    stroke: "black",
    strokeWidth: 0.817071,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9974 39.5114C23.1901 39.5114 23.3464 39.3552 23.3464 39.1624C23.3464 38.9697 23.1901 38.8135 22.9974 38.8135C22.8047 38.8135 22.6484 38.9697 22.6484 39.1624C22.6484 39.3552 22.8047 39.5114 22.9974 39.5114Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2318 39.6413C28.4245 39.6413 28.5807 39.485 28.5807 39.2923C28.5807 39.0996 28.4245 38.9434 28.2318 38.9434C28.039 38.9434 27.8828 39.0996 27.8828 39.2923C27.8828 39.485 28.039 39.6413 28.2318 39.6413Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2210_18623)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    width: 70,
    height: 70,
    rx: 35,
    fill: "#55B653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0323 16.3066C65.9246 16.3066 60.16 23.1197 60.16 31.5272C60.16 34.7708 55.8797 37.7827 57.3444 40.2527H89.4701C90.9348 37.7827 85.9006 34.7747 85.9006 31.5272C85.9006 23.1197 80.1399 16.3066 73.0323 16.3066Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6024 42.0787L57.495 42.7109C52.0249 42.7109 48.6124 45.3262 41.1278 54.7742C41.1278 54.7742 26.2725 74.7463 24.5722 76.5879C18.3363 85.0896 26.6495 92.747 34.1537 92.158C37.7389 91.8792 56.6429 85.9692 56.6429 85.9692V90.4066C56.6429 90.4066 61.9677 86.1185 65.7493 86.7546C68.5138 87.218 71.1094 89.9 71.1094 89.9C73.8896 86.1499 82.6073 82.384 81.7787 89.9C81.7787 89.9 84.1623 87.379 92.2281 87.379C100.298 87.379 101.15 89.9 101.15 89.9L101.221 85.1682C101.221 85.1682 104.723 86.8371 105.862 87.0805C115.251 90.4066 120.183 80.719 116.893 74.5381C115.887 71.4516 103.773 49.9834 103.867 50.1994C100.616 43.3431 93.6693 41.9294 90.6024 42.0787Z",
    fill: "#FF85D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0351 60.0984C79.9644 59.2188 80.0469 57.4988 80.9501 57.6598C82.0771 57.8601 83.534 60.0984 84.7866 59.262C85.411 58.7593 84.7316 56.6545 85.2146 56.0537",
    stroke: "white",
    strokeWidth: 0.807812,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0664 53.1287C56.9957 52.249 57.0781 50.5291 57.9813 50.6901C59.1083 50.8903 60.5652 53.1287 61.8179 52.2922C62.4422 51.7896 61.7629 49.6848 62.2459 49.084",
    stroke: "white",
    strokeWidth: 0.807812,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6523 71.4275C40.5816 70.5479 40.6641 68.8279 41.5673 68.9889C42.6943 69.1892 44.1511 71.4275 45.4038 70.5911C46.0282 70.0884 45.3488 67.9836 45.8318 67.3828",
    stroke: "white",
    strokeWidth: 0.807812,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6679 64.1472C99.5972 63.2676 99.6797 61.5476 100.583 61.7086C101.71 61.9089 103.167 64.1472 104.419 63.3108C105.044 62.8081 104.364 60.7033 104.847 60.1025",
    stroke: "white",
    strokeWidth: 0.807812,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.082 47.9997C90.0113 47.1201 90.0938 45.4002 90.997 45.5612C92.124 45.7614 93.5808 47.9998 94.8335 47.1633C95.4579 46.6607 94.7785 44.5559 95.2615 43.9551",
    stroke: "white",
    strokeWidth: 0.807812,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2211 29.2922L64.1844 27.4662C65.4606 27.0656 70.5263 22.8403 70.7344 20.8887C71.3627 22.9228 77.0527 28.0591 79.0751 28.7856L79.5188 30.8197C81.3684 29.2922 83.8973 29.5631 84.5099 31.397C85.3384 34.6523 82.6956 35.6105 79.8251 35.4888V38.4653V43.5938C79.8251 43.5938 78.7727 44.9093 77.5868 45.5023C73.601 47.7131 69.843 45.0232 68.8731 43.5938V38.858C67.695 38.858 65.225 39.0072 64.1883 36.9338C63.1202 34.8094 64.2158 31.0985 65.2211 29.2922Z",
    fill: "#F1F9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8477 40.9161L72.5311 38.4854C72.5311 38.4854 71.3884 38.6817 70.658 38.7524C69.9472 38.8231 68.8438 38.8584 68.8438 38.8584V40.9161H68.8477Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0815 27.5723C68.7202 29.4336 70.1456 30.5253 70.1456 30.5253L68.4453 33.5293H70.4519",
    stroke: "black",
    strokeWidth: 0.807812,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6094 27.5489C73.1984 27.4468 73.7953 27.4586 74.2076 27.5764",
    stroke: "black",
    strokeWidth: 0.807812,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2812 27.1954C66.8703 27.0933 67.4672 27.105 67.8795 27.2228",
    stroke: "black",
    strokeWidth: 0.807812,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6875 35.3675C72.2176 35.0887 72.681 34.7118 72.9362 34.3701",
    stroke: "black",
    strokeWidth: 0.807812,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8125 32.7289L82.9487 30.9893",
    stroke: "black",
    strokeWidth: 0.807812,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.375 31.6172L83.5099 32.7285",
    stroke: "black",
    strokeWidth: 0.807812,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4902 30.2977C73.6875 30.2977 73.8475 30.1377 73.8475 29.9404C73.8475 29.743 73.6875 29.583 73.4902 29.583C73.2928 29.583 73.1328 29.743 73.1328 29.9404C73.1328 30.1377 73.2928 30.2977 73.4902 30.2977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.162 29.9442C67.3594 29.9442 67.5194 29.7842 67.5194 29.5868C67.5194 29.3895 67.3594 29.2295 67.162 29.2295C66.9647 29.2295 66.8047 29.3895 66.8047 29.5868C66.8047 29.7842 66.9647 29.9442 67.162 29.9442Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0559 19.0151C87.7731 16.8534 87.6207 13.874 85.7154 12.3605C83.8101 10.8469 80.8734 11.3724 79.1562 13.5341C77.439 15.6958 77.5914 18.6752 79.4967 20.1887C81.402 21.7023 84.3387 21.1768 86.0559 19.0151Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2915 32.8622C67.1869 32.8622 68.7235 31.3256 68.7235 29.4301C68.7235 27.5346 67.1869 25.998 65.2915 25.998C63.396 25.998 61.8594 27.5346 61.8594 29.4301C61.8594 31.3256 63.396 32.8622 65.2915 32.8622Z",
    stroke: "black",
    strokeWidth: 0.807812
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9946 32.8622C75.8901 32.8622 77.4267 31.3256 77.4267 29.4301C77.4267 27.5346 75.8901 25.998 73.9946 25.998C72.0991 25.998 70.5625 27.5346 70.5625 29.4301C70.5625 31.3256 72.0991 32.8622 73.9946 32.8622Z",
    stroke: "black",
    strokeWidth: 0.807812
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3828 31.0947H70.9745",
    stroke: "black",
    strokeWidth: 0.807812
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4531 29.9092H79.7935",
    stroke: "black",
    strokeWidth: 0.807812
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2210_18623"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 20,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2210_18623"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2210_18623"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    width: 70,
    height: 70,
    rx: 35,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqImage1);
export default __webpack_public_path__ + "static/media/faqImage1.9b089960db888a62a75cbc4d863f5fe0.svg";
export { ForwardRef as ReactComponent };